"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTenderAcceptance = function SvgIconTenderAcceptance(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "tender acceptance icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Tender Acceptance Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.83 6.004A.75.75 0 006 6.75v28.161l.005.058a.375.375 0 00.574.255A4.423 4.423 0 019 34.5a4.5 4.5 0 014.5 4.5 4.2 4.2 0 01-.133 1.033.378.378 0 00.067.323c.07.095.182.15.3.15l14.206.002 1.106-.023a.377.377 0 00.34-.466A4.17 4.17 0 0129.25 39a4.49 4.49 0 118.982 0 .378.378 0 00.375.383h2.268l.112-.006A1.125 1.125 0 0042 38.25v-7.102l-.003-.133a2.623 2.623 0 00-1.958-2.405l-5.196-1.363-.082-.025a.963.963 0 01-.636-.905 7.876 7.876 0 00-3.72-6.713L27 17.477l-.092-.051a1.351 1.351 0 00-.297-.11.377.377 0 01-.245-.202 6.345 6.345 0 00-5.712-3.615H17.25l-.082.004a.75.75 0 00-.668.746v20.625l-.005.06a.375.375 0 01-.37.315h-1.5l-.06-.005a.375.375 0 01-.315-.37V11.94l.002-.17a5.177 5.177 0 00-3.845-4.976l-3.494-.776-.083-.014zM21 21.75h1.5l.082.004a.75.75 0 01.668.746V27l-.004.082a.75.75 0 01-.746.668H21l-.082-.004A.75.75 0 0120.25 27v-4.5l.004-.082A.75.75 0 0121 21.75zm7.27.027a.374.374 0 00-.555.258l-.006.066v4.149c0 .186.136.341.315.37l.06.005h2.655a.375.375 0 00.375-.396 5.181 5.181 0 00-2.844-4.452zM9 36a3 3 0 110 6 3 3 0 010-6zm24.75 0a3 3 0 110 6 3 3 0 010-6z"
  }));
};

var _default = SvgIconTenderAcceptance;
exports.default = _default;